import React, { Component } from 'react'
import { Linking } from 'react-native'
import { SHr, SPage, SText, STheme, SView } from 'servisofts-component';
import { Container } from '../Components';

const SUPPORT_EMAIL = "servisofts.srl@gmail.com";

export default class contacto extends Component {
    render() {
        return (
            <SPage title={"Soporte técnico — RENOVA"}>
                <Container>
                    <SHr height={30} />
                    <SView col={"xs-12"} center>
                        <SView width={64} height={64} center style={{ borderRadius: 14, backgroundColor: STheme.color.success + "22" }}>
                            <SText fontSize={30}>🎧</SText>
                        </SView>
                        <SHr height={20} />
                        <SText bold center fontSize={20}>¿Necesitas ayuda?</SText>
                        <SHr height={10} />
                        <SText center fontSize={14}>
                            Estamos aquí para ayudarte. Si tienes alguna consulta, inconveniente o sugerencia sobre la aplicación RENOVA, puedes comunicarte con nuestro equipo de soporte.
                        </SText>
                    </SView>
                    <SHr height={20} />
                    <SView col={"xs-12"} card style={{ padding: 16, borderRadius: 12 }}>
                        <SText bold fontSize={15}>✉️  Correo electrónico de contacto</SText>
                        <SHr height={12} />
                        <SText fontSize={16} color={STheme.color.success} onPress={() => Linking.openURL(`mailto:${SUPPORT_EMAIL}`)}>
                            {SUPPORT_EMAIL}
                        </SText>
                        <SHr height={8} />
                        <SText fontSize={12}>Envíanos un correo describiendo tu consulta o problema.</SText>
                    </SView>
                    <SHr height={20} />
                    <SText center fontSize={12} color={STheme.color.gray}>RENOVA © {new Date().getFullYear()}. Todos los derechos reservados.</SText>
                    <SHr height={40} />
                </Container>
            </SPage>
        )
    }
}
